__turbopack_context__.v({
  "avatarWrapper": "QIc-PG_avatarWrapper",
  "bottomLeftPicture": "QIc-PG_bottomLeftPicture",
  "container": "QIc-PG_container",
  "feedbackContainer": "QIc-PG_feedbackContainer",
  "picturePanels": "QIc-PG_picturePanels",
  "reviewCount": "QIc-PG_reviewCount",
  "rightPicture": "QIc-PG_rightPicture",
  "shopInfo": "QIc-PG_shopInfo",
  "shopName": "QIc-PG_shopName",
  "topLeftPicture": "QIc-PG_topLeftPicture",
});
